import React, { useState } from "react";
import axios from "axios";
import "./LegalApp.css";

const RightUserRating = ({ API_URL, id, bucketFileName, right, rightRatingMap, setRecheckPendingRatings }) => {
  const [rating, setRating] = useState(rightRatingMap != null && rightRatingMap[right.id] != null ? rightRatingMap[right.id] : 0);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmSubmitted, setConfirmSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [rated, setRated] = useState(rightRatingMap != null && rightRatingMap[right.id] != null ? true : false);

  // Function to handle star click
  const handleRating = (selectedRating) => {
    if (rated) {
      return;
    }
    //console.log(`Selected rating: ${selectedRating}`);
    setRating(selectedRating);
    setShowConfirm(true);
  };

  const cancelSubmitRating = () => {
    setShowConfirm(false);
  };

  const handleConfirm = async () => {
    setIsLoading(true);

    var jwt = localStorage.getItem('jwtToken');
    var email = localStorage.getItem('email');
    var user = localStorage.getItem('role');

    const request = {
      email: email,
      user: user,
      firId: id,
      bucketFileName: bucketFileName,
      rightId: right.id,
      title: right.title,
      description: right.description,
      remedy: right.remedy,
      rating: rating,
    }

    try {
      const response = await axios.post(API_URL + `/rating/right`, request, {
        headers: {
          'Content-Type': 'application/json', // Set the content type to JSON
          'Authorization': `Bearer ${jwt}`,
        },
      });

      //console.log(response.data);
      setRated(true);
      setConfirmSubmitted(true);
      setRecheckPendingRatings(Date.now());
      rightRatingMap[right.id] = rating;

      localStorage.removeItem('firList');
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage("An error occurred while processing the request. Please try again later.");
    } finally {
      setShowConfirm(false);
      setIsLoading(false);
    }
  };

  const closeConfirmSubmitted = (e) => {
    e.preventDefault();
    setConfirmSubmitted(false);
  };

  const closeErrorPopup = (e) => {
    e.preventDefault();
    setErrorMessage(null);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", fontFamily: "Arial, sans-serif" }}>
      {/* Caption */}
      <p style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}>
        How helpful is this legal right for you?
      </p>

      {/* Star Rating Selection */}
      <div>
        {Array(5).fill(null).map((_, index) => {
          const starIndex = index + 1;
          return (
            <span
              key={index}
              onClick={() => handleRating(starIndex)}
              disabled={rated}
              style={{
                fontSize: "18px",
                cursor: rated ? "default" : "pointer",
                color: starIndex <= rating ? "#E67E22" : "#D3D3D3", // Filled or empty star
              }}
            >
              ★
            </span>
          )
        })}
      </div>

      {showConfirm && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h3>Confirm Rating</h3>
            <p>Click Confirm to submit a rating of <strong>{rating}</strong>.</p>
            <div className="popup-buttons">
              <button onClick={cancelSubmitRating} className="cancel-button" disabled={isLoading}>Cancel</button>
              <button onClick={handleConfirm} className="submit-popup-button" disabled={isLoading}>
                {isLoading ? <div className="spinner"></div> : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmSubmitted && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Thank you</h2>
            <p>We’ve recorded your rating.</p>
            <div className="popup-buttons">
              <button
                className="submit-popup-button"
                onClick={(e) => closeConfirmSubmitted(e)}
              >Close</button>
            </div>
          </div>
        </div>
      )}

      {errorMessage && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Error</h2>
            <p>Please try again later.</p>
            <div className="popup-buttons">
              <button
                className="submit-popup-button"
                onClick={(e) => closeErrorPopup(e)}
              >Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RightUserRating;
